/** Remember only the builder route, never a position FEN or game data. */
const key = (repertoireId: string): string => `chessreps:recent-builder:${repertoireId}`;

export function rememberBuilderRoute(repertoireId: string, route: string): void {
  if (!route.startsWith(`/repertoires/${repertoireId}/nodes/`)) return;
  try {
    window.localStorage.setItem(key(repertoireId), route);
  } catch {
    // Private browsing or a storage policy must not interrupt building.
  }
}

export function recentBuilderRoute(repertoireId: string, fallback: string): string {
  try {
    const route = window.localStorage.getItem(key(repertoireId));
    if (route?.startsWith(`/repertoires/${repertoireId}/nodes/`)) return route;
  } catch {
    // A missing storage permission should just start at the repertoire root.
  }
  return fallback;
}
